import Reveal from '@/components/feature/Reveal';
import SectionTitle from './SectionTitle';
import { TESTIMONIALS } from '@/mocks/anime';

const PRINCIPLES = [
  { icon: 'ri-door-open-fill', title: '入口清晰', desc: '所有热门作品与新番入口集中呈现，打开即看、直达对应页面。' },
  { icon: 'ri-time-fill', title: '更新及时', desc: '持续跟进新番连载与更新安排，第一时间掌握每周追更动态。' },
  { icon: 'ri-focus-2-fill', title: '分类专业', desc: '按热血、奇幻、恋爱、治愈等主题科学分类，找番更有方向。' },
  { icon: 'ri-heart-fill', title: '体验贴心', desc: '以动漫爱好者视角打磨入口体验，让追更成为一种享受。' },
];

export default function About() {
  return (
    <section id="about" className="relative overflow-hidden bg-background-100/70 py-16 md:py-24">
      <div className="pointer-events-none absolute left-1/2 top-0 h-56 w-56 -translate-x-1/2 rounded-full bg-primary-100/60 blur-3xl"></div>
      <div className="relative mx-auto max-w-7xl px-4 md:px-6">
        <SectionTitle
          eyebrow="关于我们"
          title="想做动漫爱好者的追更好伙伴"
          desc="卡通动漫第一页坚持以「打开即看、追更不迷路」为核心，把分散的动漫入口集中起来，用清晰的结构与用心的分类，陪伴每一位漫迷找到热爱。"
        />

        {/* 品牌理念 */}
        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-5">
          {PRINCIPLES.map((p, i) => (
            <Reveal key={p.title} delay={i * 60}>
              <div className="flex flex-col items-start rounded-2xl border border-background-200 bg-background-50 p-6 transition-all hover:-translate-y-1 hover:border-primary-300">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-100 text-primary-700">
                  <i className={`${p.icon} text-xl`}></i>
                </span>
                <h3 className="mt-4 font-heading text-base text-foreground-950">{p.title}</h3>
                <p className="mt-2 text-sm leading-6 text-foreground-600">{p.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        {/* 用户口碑 */}
        <Reveal className="mt-14">
          <h3 className="text-center font-heading text-xl text-foreground-950 md:text-2xl">他们都在卡通动漫第一页追更</h3>
        </Reveal>
        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3 md:gap-6">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={i * 70}>
              <figure className="flex h-full flex-col rounded-2xl border border-background-200 bg-background-50 p-6">
                <div className="flex items-center gap-1 text-secondary-500">
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                </div>
                <blockquote className="mt-4 flex-1 text-sm leading-7 text-foreground-700">「{t.quote}」</blockquote>
                <figcaption className="mt-5 flex items-center gap-3">
                  <img src={t.avatar} alt={`${t.name} 头像`} className="h-10 w-10 rounded-full object-cover" />
                  <div>
                    <p className="text-sm font-semibold text-foreground-950">{t.name}</p>
                    <p className="text-xs text-foreground-500">{t.role}</p>
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}